var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damage-form" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("csp-form-group-datepicker", {
              attrs: {
                form: _vm.damageSubform,
                "label-property": "accidentDateTimeForCustomer",
                property: "accidentDateTime",
                required: "",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-4 mb-0" }, [
        _vm._v("\n        Wo ist der Unfall passiert?\n    "),
      ]),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          attrs: { align: "center" },
          on: { "activate-tab": _vm.accidentPlaceTabActivate },
        },
        [
          _c(
            "b-tab",
            {
              attrs: { active: "" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "tab-title" }, [
                        _vm._v("Ort eingeben"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "tab-body" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("gmap-autocomplete", {
                      staticClass: "form-control",
                      attrs: { value: _vm.accidentPlace },
                      on: { place_changed: _vm.setPlace },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "tab-title" }, [
                        _vm._v("Auf Karte suchen"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-body map-body text-center mb-3" },
                [
                  _c(
                    "div",
                    { staticClass: "gmap-overflow-search" },
                    [
                      _c("gmap-autocomplete", {
                        attrs: { value: _vm.accidentPlace },
                        on: { place_changed: _vm.setPlace },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "gmap-map",
                    {
                      ref: "map",
                      class: "mx-auto",
                      staticStyle: { width: "100%", height: "400px" },
                      attrs: { center: _vm.maps.center, zoom: 12 },
                      on: { click: _vm.markerHandling },
                    },
                    [
                      _vm.maps.marker.lat
                        ? _c("GmapMarker", {
                            attrs: { position: _vm.maps.marker },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("csp-form-group-radio", {
              attrs: {
                form: _vm.damageSubform,
                "label-property": "isRecordedByPoliceForCustomer",
                options: _vm.isRecordedByPoliceOptions,
                property: "isRecordedByPolice",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("csp-form-group-optional-bool", {
              attrs: {
                "align-horizontal": "",
                form: _vm.damageSubform,
                "label-cols": null,
                "label-property": "isRentalCarUsedForCostumer",
                property: "isRentalCarUsed",
                type: "text",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }